import { render } from "./registerPage.vue?vue&type=template&id=59c832a5&scoped=true"
import script from "./registerPage.vue?vue&type=script&lang=js"
export * from "./registerPage.vue?vue&type=script&lang=js"

import "./registerPage.vue?vue&type=style&index=0&id=59c832a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c832a5"],['__file',"src/views/RegisterPage/registerPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59c832a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59c832a5', __exports__)) {
    api.reload('59c832a5', __exports__)
  }
  
  module.hot.accept("./registerPage.vue?vue&type=template&id=59c832a5&scoped=true", () => {
    api.rerender('59c832a5', render)
  })

}


export default __exports__